import { isVue3 } from 'vue-demi';

const created$1 = (element, binding) => {
  element.addEventListener('keydown', event => {
    if (['Escape'].includes(event.key)) {
      binding.value(event);
    }
  });
};
const DropdownClose = {
  [isVue3 ? 'created' : 'bind']: created$1
};

const created = (element, binding) => {
  element.addEventListener('keydown', event => {
    if (['Enter', ' '].includes(event.key)) {
      binding.value(event);
    }
  });
  element.addEventListener('click', event => {
    event.stopPropagation();
    event.preventDefault();
    binding.value(event);
  });
};
const DropdownOpen = {
  [isVue3 ? 'created' : 'bind']: created
};

export { DropdownClose as D, DropdownOpen as a };
